import { useEffect } from 'react';
import { sentry } from '@frontend/tracking';
import { useRouter } from '@frontend/weave-router';
import { useAppStatus } from '../providers/app-status.provider';
import { useApp } from '../providers/app.provider';

export const useOutsideAuthenticatedAppCheck = (page: string) => {
  const { refresh } = useApp();
  const status = useAppStatus();
  const isMounted = status?.isMounted;
  const router = useRouter();

  useEffect(() => {
    if (!isMounted) {
      const timeout = setTimeout(() => {
        if (!status?.isMounted) {
          sentry.error({
            error: `${page} page rendered outside of AuthenticatedApp`,
            topic: 'infra',
            severityLevel: 'error',
            addContext: {
              name: 'router state',
              context: {
                isMounted: status?.isMounted,
                state: router.state,
                latestLocation: router.latestLocation,
                windowPathname: window.location.pathname,
              },
            },
          });
          refresh('hard', page + ' page rendered outside of authenticated app');
        }
      }, 150);
      return () => clearTimeout(timeout);
    }
    return;
  }, [isMounted, router.state]);
};
